import React, { useState, useRef, useEffect } from 'react';
import Transition from "../mosaic/utils/Transition.jsx";
import useUserSettings from "../utils/useUserSettings.js";
import Button from "./Button.jsx";

function FilterButton({ button, onClick}) {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    let [userSettings, setUserSettings] = useUserSettings();

    return (
        <div className="filter-wrap relative inline-flex">
            <Button
                variant="outline-black"
                onClick={onClick}
                aria-haspopup="true"
                aria-expanded={dropdownOpen}
            >
                {button}
            </Button>
        </div>
    );
}

export default FilterButton;